"use client";
import {
  asMenuItem,
  findOwnerMenuItem,
  useMenu,
} from "@/context/menu-context";
import { useUnit } from "@/context/unit-context";
import { EfnAuth } from "@/services/auth/types";
import { usePathname } from "next/navigation";
import ActiveLink from "../active-link";
import Icon from "../icon";
import MenuToggle from "../menu-toggle";
import NavSearch from "./nav-search";

type NavigationProps = {
  user: EfnAuth.UserCookie | null;
};

const Navigation = (props: NavigationProps) => {
  const headerMenu = useMenu("menu-header");
  const menuItems = headerMenu?.fields?.menuItems ?? [];
  const pathname = usePathname();
  const { currentUnit } = useUnit();
  let owner = findOwnerMenuItem(headerMenu, pathname);
  if (!owner && currentUnit) {
    const unitSlug = currentUnit.replace(/^unit-/, "");
    owner = menuItems
      .map(asMenuItem)
      .find((mi) => mi?.fields?.item?.fields?.slug === unitSlug);
  }

  return (
    <nav aria-label="Huvudmeny" className="bg-sand-600 relative z-30">
      <div className="container relative flex justify-between items-center pr-0 pl-0 after:content-[''] after:absolute after:top-0 after:right-[100px] after:h-full after:w-12 after:bg-gradient-to-r after:from-transparent after:to-sand-600 after:pointer-events-none after:z-10">
        <ul className="whitespace-nowrap overflow-auto hide-scrollbar uppercase p-0">
          {menuItems.map((menuItem, index) => {
            const rawHref =
              menuItem.fields.item?.fields?.slug ??
              menuItem.fields.url ??
              "#";
            const normalized =
              rawHref === "#" || rawHref.startsWith("/")
                ? rawHref
                : `/${rawHref}`;
            const href =
              normalized === "/index" ? "/" : normalized;
            const activeClassName = "after:bg-red-700 dark:after:bg-static-white";
            const isActive = owner?.sys.id === menuItem.sys.id;
            return (
              <li className="inline-block" key={`menu-item-${index}`}>
                <ActiveLink
                  matchSubPaths
                  isActive={isActive}
                  activeClassName={activeClassName}
                  className="relative block text-gray-500 hover:bg-sand-700 font-bold text-sm md:text-base px-3 py-4 text-center after:content-[''] after:h-[5px] after:w-full after:absolute after:bottom-0 after:inset-x-0 after:z-10"
                  href={href}
                >
                  {menuItem.fields.label}
                </ActiveLink>
              </li>
            );
          })}
        </ul>

        <div className="flex items-center leading-none">
          <NavSearch />
          <MenuToggle
            className="h-[50px] w-[50px]  flex items-center justify-center hover:bg-sand-700 border-l border-sand-800"
            type="menu"
            aria-label="Sidomeny"
          >
            <Icon.Menu />
          </MenuToggle>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
